export interface Genre {
  id: string;
  name: string;
  desc: string;
  icon: string;
  accentText: string;
  accentBg: string;
  gradient: string;
}

export const genres: Genre[] = [
  {
    id: "campus",
    name: "校园",
    desc: "青春校园里的悸动与成长，从课桌到天台的故事",
    icon: "ri-graduation-cap-line",
    accentText: "text-primary-700",
    accentBg: "bg-primary-100",
    gradient: "from-primary-500 to-primary-300",
  },
  {
    id: "fantasy",
    name: "奇幻",
    desc: "魔法、异世界与神魔之间的幻想冒险之旅",
    icon: "ri-magic-line",
    accentText: "text-accent-700",
    accentBg: "bg-accent-100",
    gradient: "from-accent-500 to-accent-300",
  },
  {
    id: "urban",
    name: "都市",
    desc: "霓虹都市中的契约、猎人与都市异闻",
    icon: "ri-building-2-line",
    accentText: "text-secondary-800",
    accentBg: "bg-secondary-100",
    gradient: "from-secondary-500 to-secondary-300",
  },
  {
    id: "romance",
    name: "恋爱",
    desc: "心动、暗恋与双向奔赴的甜蜜恋爱情节",
    icon: "ri-heart-3-line",
    accentText: "text-primary-700",
    accentBg: "bg-primary-100",
    gradient: "from-primary-500 to-accent-400",
  },
  {
    id: "mystery",
    name: "悬疑",
    desc: "迷雾背后的真相，沉浸式烧脑推理体验",
    icon: "ri-search-eye-line",
    accentText: "text-accent-700",
    accentBg: "bg-accent-100",
    gradient: "from-accent-600 to-primary-500",
  },
];

export function getGenre(id: string): Genre {
  return genres.find((g) => g.id === id) ?? genres[0];
}